import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import type { ViewId } from 'balus-common';

type Return = {
  isSelected: boolean;
};

export const useSidebarView = (viewId: ViewId): Return => {
  const { search } = useLocation();

  const isSelected = useMemo(() => {
    const query = new URLSearchParams(search);
    const targetViewId = query.get('targetView');
    return viewId === targetViewId;
  }, [viewId, search]);

  return {
    isSelected,
  };
};
